import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGearIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 16.6 16.6",
	style: { enableBackground: "new 0 0 16.6 16.6" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		children: "\n	.gear-icon-st0{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;}\n"
	}), /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
		className: "gear-icon-st0",
		d: "M8.3,12.1c2.1,0,3.8-1.7,3.8-3.8s-1.7-3.8-3.8-3.8S4.5,6.2,4.5,8.3S6.2,12.1,8.3,12.1z"
	}), /* @__PURE__ */ _jsx("path", {
		className: "gear-icon-st0",
		d: "M12.7,3.4c0.2,0.2,0.4,0.4,0.6,0.6l2,0.3c0.3,0.6,0.6,1.2,0.8,1.9l-1.3,1.7c0,0,0,0.5,0,0.8l1.3,1.7 c-0.2,0.7-0.4,1.3-0.8,1.9l-2.1,0.3c0,0-0.4,0.4-0.6,0.6l-0.3,2.1c-0.6,0.3-1.2,0.6-1.9,0.8l-1.7-1.3c-0.3,0-0.5,0-0.8,0 l-1.7,1.3c-0.7-0.1-1.3-0.4-1.9-0.8L4,13.2c-0.2-0.2-0.4-0.4-0.6-0.6l-2.1-0.3c-0.3-0.6-0.6-1.2-0.8-1.9l1.3-1.7c0,0,0-0.5,0-0.8 L0.5,6.2c0.1-0.7,0.4-1.3,0.8-1.9L3.4,4C3.6,3.8,3.8,3.6,4,3.4l0.3-2.1C4.9,1,5.5,0.7,6.2,0.5l1.7,1.3c0.3,0,0.5,0,0.8,0l1.7-1.3 c0.7,0.1,1.3,0.4,1.9,0.8L12.7,3.4z"
	})] }) }) })]
});
export default SvgGearIcon;
